import { useEffect, useState } from 'react';

const useAuthentication = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const responseHandler = ({ statusCode }) => {
    if (statusCode === 0) {
      setIsAuthenticated(true);
    } else if (statusCode === 101) {
      setIsAuthenticated(false);
    }

    window?.AmexSession?.closeSessionFrame();
  };

  useEffect(() => {
    let attempts = 0;
    const maxAttempts = 10;

    const interval = setInterval(async () => {
      attempts += 1;

      const session = window?.AmexSession;

      if (!session) {
        /* istanbul ignore next */
        if (attempts >= maxAttempts) {
          clearInterval(interval);
        }

        return;
      }

      try {
        const isAuth = await session.isUserAuthenticated();

        if (isAuth) {
          setIsAuthenticated(true);
        } else {
          session.login({
            autoClose: true,
            style: 'light',
            callback: responseHandler,
          });
        }

        clearInterval(interval);
      } catch (err) {
        /* istanbul ignore next */
        if (attempts >= maxAttempts) {
          clearInterval(interval);
        }
      }
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return isAuthenticated;
};

export default useAuthentication;
